var loginInit = function () {


    var loginButton = $('[data-id="login-button"]'),
        loginForm = $('[data-id="login-form"]'),
        loginFormSubmitButton = $('[data-id="login-form"] input[type="submit"]'),
        resendCodeButton = $('[data-id="resend-button"]'),
        errorPanel = $('[data-id="login-form"] [data-id="errormessages"]'),
        infoPanel = $('[data-id="login-form"] [data-id="infomessages"]'),
    successPanel = $('[data-id="login-form"] [data-id="successmessages"]'),
    validationerrorpanel = $('[data-id="login-form"] [data-id="validationerrormessage"]'),
    partialregistrationerrorpanel = $('[data-id="login-form"] [data-id="partialregistrationerrormessage"]'),
    loginButtonEnabled = $('[data-id="login-button"]:not(.disable)');


    //Mobile Login
    var loginMobile = function () {
        
        loginButtonEnabled.off("click.fb-start"); // AC-1384 prevents desktop login overlay from triggering when user zooms in
        loginButtonEnabled.off('click.screensize').on("click.screensize", function (evt) {
            evt.preventDefault();
            loginForm.slideToggle()
        });

        //for content login links to scroll to top
        $('[data-scrolltoEl="login"]').on("click", function () {
            $('html, body').animate({ scrollTop: 0 }, 800);
            loginForm.slideDown();
            return false;
        });

        //add close button
        loginForm.prepend('<button data-id="close-login" type="button" class="btn-close"><span class="visually-hidden">Close</span><span class="icon-close"></span></button>');
        $('[data-id="close-login"]').on("click", function () {
            loginForm.slideUp();

        });
    };

    //Desktop Login
    var loginDesktop = function () {

        loginButtonEnabled.off('click.screensize').fancybox({ tpl: { wrap: '<div class="fancybox-wrap" role="dialog" aria-modal="true" aria-labelledby="login-register-button" id="login-dialog"><div class="fancybox-skin"><div class="fancybox-outer"><div class="fancybox-inner"></div></div></div></div>' }, afterShow: handleFocus, afterClose: () => loginButton.focus() });

        $('[data-id="close-login"]').remove();
    };

    enquire.register("screen and (max-width:47.9375em)", {
        match: function () {            
            $(document).off('click.fb-start');
            loginMobile();
        },
        unmatch: function () {
            loginForm.hide();
            loginDesktop();
        }
    });

    enquire.register("screen and (min-width:48em)", {
        match: function () {
            loginDesktop();
        },
        unmatch: function () {
            $.fancybox.close();
        }
    }, true);

    if (mando.getUrlParameter(mando.strings.Param_DoLogin)) {
        loginButton.on('click');
    }

    function getValidationToken() {
        var query = window.location.search.substring(1);
        var vars = query.split("?token=");
        if (vars[1]) { return vars[1]; } else {
            return (false);
        }
    }

    loginForm.on('submit', function (evt) {

        var f = loginForm.serialize(); f += "&" +
        loginFormSubmitButton.attr("name") + "=" +
        loginFormSubmitButton.attr("value"); if (getValidationToken()) {
            f
            += "&ValidationToken" + "=" + getValidationToken();
        }

        evt.preventDefault();

        if (loginForm.valid()) {

            var loginUrl = mando.strings.URL_Login + location.search;

            $.post(loginUrl, f).then(
                function (result) {
                    if (result.LoginSuccess) {

                        if (result.RedirectUrl)
                            window.location.href = result.RedirectUrl;
                        else
                            window.location.replace(window.location.href);
                    }
                    else {
                        //show validation error message
                        if (result.ShowPartialRegistrationMessage) {
                            partialregistrationerrorpanel.show();
                            validationerrorpanel.show();
                            infoPanel.hide();
                            successPanel.hide();
                            errorPanel.hide();
                            return;
                        }
                        else if (result.ShowValidationFailedMessage) {
                            validationerrorpanel.show();
                            partialregistrationerrorpanel.hide();
                            infoPanel.hide();
                            successPanel.hide();
                            errorPanel.hide();
                            return;
                        }
                        else if (result.ShowUserNotValidatedMessage) {
                            partialregistrationerrorpanel.hide();
                            infoPanel.show();
                            successPanel.hide();
                            errorPanel.hide();
                            return;
                        }
                        else {
                            infoPanel.hide();
                        }

                        if (result.ShowValidationCodeSentMessage) {
                            successPanel.show();
                            infoPanel.hide();
                            errorPanel.hide();
                            return;
                        }
                        else {
                            successPanel.hide();
                        }

                        errorPanel.empty();
                        errorPanel.append('<div class="m-form-error"></div>');

                        var errorContainer = errorPanel.find('.m-form-error');

                        $.each(result.Errors, function (index, value) {
                            errorContainer.append('<span class="field-validation-error">' + value + '</span>');
                        });
                    }
                },
            function () { }
            );
        }
    });

    loginForm.on("invalid-form.validate", (form, validator) => {
        const errors = validator.numberOfInvalids();
        if (errors) {
            validator.errorList[0].element.focus();
        }
    });

    resendCodeButton.on('click', function (evt) {

        var f = loginForm.serialize();
        f += "&" + this.name + "=" + this.value;

        evt.preventDefault();

        if (loginForm.valid()) {

            var loginUrl = mando.strings.URL_Login + location.search;

            $.post(loginUrl, f).then(
                function (result) {
                    if (result.LoginSuccess) {

                        if (result.RedirectUrl)
                            window.location.href = result.RedirectUrl;
                        else
                            window.location.replace(window.location.href);
                    }
                    else {
                        if (result.ShowUserNotValidatedMessage) {
                            infoPanel.show();
                            successPanel.hide();
                            return;
                        }
                        else {
                            infoPanel.hide();
                        }

                        if (result.ShowValidationCodeSentMessage) {
                            successPanel.show();
                            infoPanel.hide();
                            return;
                        }
                        else {
                            successPanel.hide();
                        }

                        errorPanel.empty();
                        errorPanel.append('<div class="m-form-error"></div>');

                        var errorContainer = errorPanel.find('.m-form-error');

                        $.each(result.Errors, function (index, value) {
                            errorContainer.append('<span class="field-validation-error">' + value + '</span>');
                        });
                    }
                },
                function () { }
            );
        }
    });

    // Passing Values to Login Form Hidden Fields

    var loginInlineButton = $('[data-login="inline"]');

    if (loginInlineButton[0]) {

        loginInlineButton.on("click", function (e) {

            var loginSource = $(this).data('loginsource'),
                loginSourceId = $(this).data('loginsource-id');
            $('.m-login #LoginSource').val(loginSource);
            $('.m-login #LoginSourceId').val(loginSourceId);

        });

    }
}

var focusTrap = function (trapSelector, delegateSelector, initialFocusSelector) {

    $(initialFocusSelector).focus();

    var tabbableElements = $(trapSelector).find('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');

    // add fancybox close button to the list of tabbable elements
    var focusableEls = Array.from(tabbableElements);
    focusableEls.push($("a.fancybox-close")[0]);

    var firstFocusableEl = focusableEls[0];
    var lastFocusableEl = focusableEls[focusableEls.length - 1];
    var KEYCODE_TAB = 9;

    //delegate eventListener to a parent of both the form elements and the close button
    $(delegateSelector).on('keydown', function (e) {
        var isTabPressed = (e.key === 'Tab' || e.keyCode === KEYCODE_TAB);

        if (!isTabPressed) {
            return;
        }

        if (e.shiftKey) /* shift + tab */ {
            if (document.activeElement === firstFocusableEl) {
                lastFocusableEl.focus();
                e.preventDefault();
            }
        } else /* tab */ {
            if (document.activeElement === lastFocusableEl) {
                firstFocusableEl.focus();
                e.preventDefault();
            }
        }
    });
}

var handleFocus = function () {
    // not sure why but timeout is needed otherwise focus will not happen
    setTimeout(function () {
        focusTrap("#login-form-container", "#login-dialog", "#Username")
    }, 0);
}

